import request from '@/utils/request'
import qs from 'qs'

// arrival guest menu

// api get list
// thong tin phan khuc thi truong
export function getMarketSeg(query = { isActive: 0 }) {
  return request({
    url: '/config-service/v1/statistic/market-seg-group/market-seg',
    method: 'get',
    params: query
  })
}

// cong ty, dai ly du lich
export function getAgent(query = {}) {
  return request({
    url: '/config-service/v1/agent/simple-list',
    method: 'get',
    params: query
  })
}

// tai khoan cong no, agentId can be null
export function getDebitAccByAgent(query = { agentId: null }) {
  return request({
    url: '/config-service/v1/debit-account/list-by-agent',
    method: 'get',
    params: query
  })
}

// danh sach doan
export function getBookingGroup(query = {}) {
  return request({
    url: '/booking-service/v1/booking-group/list',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, { arrayFormat: 'repeat' })
    }
  })
}

// hang phong
export function getRoomLevel(query = {}) {
  return request({
    url: '/config-service/v1/hotel/room_level/all',
    method: 'get',
    params: query
  })
}
export function getRoomLevelbyHotel(query = {}) {
  return request({
    url: '/config-service/v1/hotel/room_level',
    method: 'get',
    params: query
  })
}
// so phong
export function getRoom(query = {}) {
  return request({
    url: '/config-service/v1/hotel/room',
    method: 'get',
    params: query
  })
}

// nguoi tao
export function getAccount(query = {}) {
  return request({
    url: '/config-service/v1/account',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, { arrayFormat: 'repeat' })
    }
  })
}

// ma gia
export function getPriceCode(query = {}) {
  return request({
    url: '/config-service/v1/hotel/price-code',
    method: 'get',
    params: query
  })
}

// quoc gia
export function getListNation() {
  return request({
    url: '/config-service/v1/statistic/code/code-base',
    method: 'get',
    params: {
      pCode: 'NATION'
    }
  })
}

// room status menu
// thuoc tinh phong
export function getRoomProperty(query) {
  return request({
    url: '/config-service/v1/hotel/room_property/all',
    method: 'get',
    params: query
  })
}

// room availibility menu
// special service
export function getSpecialService(query) {
  return request({
    url: '/config-service/v1/special-service/special-service',
    method: 'get',
    params: query
  })
}
